import { ClubState, Director } from 'store/clubs/types/types';

export const initialState: ClubState = {
  clubDetails: {
    clubName: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    county: '',
    email: '',
    houseNumber: '',
    postcode: '',
    telephoneNumber: '',
    commissionTerms: '',
    sortCode: '',
    accNumber: '',
    accName: '',
  },
  directors: [
    {
      title: '',
      firstName: '',
      middleName: '',
      surname: '',
      dateOfBirth: '',
      gender: '',
      addresses: [
        {
          postCode: '',
          houseNr: '',
          line1: '',
          line2: '',
          city: '',
          county: '',
          residentFrom: '',
        },
      ],
    } as Director,
  ] as Director[],
};
